import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import '@/styles/index.css';
import { router } from '@/app/router';
import { QueryProvider } from '@/app/providers/QueryProvider';
import { ToastProvider } from '@/app/providers/ToastProvider';
import { loadRuntimeConfig, setOnUnauthorized } from '@/shared/api/client';

setOnUnauthorized(() => {
  if (!location.pathname.startsWith('/login')) {
    location.replace('/login');
  }
});

/* Production-д host-ийн /config-оос apiBaseUrl-ыг эхэлж уншаад дараа нь render
   хийнэ — эс бөгөөс эхний query-нууд localhost руу чиглэнэ. */
void loadRuntimeConfig().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryProvider>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </QueryProvider>
    </StrictMode>,
  );
});
